function initInquiryButtonOverlay(options = {}) {
  const {
    buttonText = "Anfragen",
    soldOutText = "Ausverkauft",
    addToCartSelector = 'button[data-product-atc]',
    inquirySelector = '#sealapps-bis-widget .product-restore-email'
  } = options;

  // Bereits laufende Instanz beenden
  if (window.destroyInquiryButtonOverlay) {
    window.destroyInquiryButtonOverlay();
  }

  const styleId = 'hb-inquiry-button-styles';

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');

    style.id = styleId;
    style.textContent = `
      .product-form--atc-button.hb-covered-by-inquiry {
        display: none !important;
      }

      .product-form__action-wrapper >
      .product-restore-email.hb-inquiry-button {
        flex: 1 1 0;
        align-self: flex-end;
        width: auto !important;
        max-width: none !important;
        margin: 0 !important;
      }

      .hb-inquiry-button .email-me-button {
        width: 100% !important;
        box-sizing: border-box;
        align-items: center;
        justify-content: center;
        padding: 16px;
        cursor: pointer;
        font-family: var(--hb-inquiry-font-family) !important;
        font-size: var(--hb-inquiry-font-size) !important;
        font-style: var(--hb-inquiry-font-style) !important;
        font-weight: var(--hb-inquiry-font-weight) !important;
        letter-spacing: var(--hb-inquiry-letter-spacing) !important;
        line-height: var(--hb-inquiry-line-height) !important;
        text-transform: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  let updateScheduled = false;

  function updateButton() {
    updateScheduled = false;

    const addToCartButton =
      document.querySelector(addToCartSelector);

    const widget =
      document.querySelector('#sealapps-bis-widget');

    /*
      * Nach dem Verschieben liegt der Anfragebutton nicht mehr
      * innerhalb von #sealapps-bis-widget. Deshalb beide Positionen
      * berücksichtigen.
      */
    const inquiryButton =
      document.querySelector(
        '.product-restore-email.hb-inquiry-button'
      ) ||
      document.querySelector(inquirySelector);

    if (!addToCartButton || !inquiryButton) {
      return;
    }

    const innerButton =
      inquiryButton.querySelector('.email-me-button');

    const isSoldOut =
      addToCartButton.textContent.trim() ===
      soldOutText.trim();

    if (!isSoldOut) {
      addToCartButton.classList.remove(
        'hb-covered-by-inquiry'
      );

      if (
        widget &&
        inquiryButton.parentElement !== widget
      ) {
        widget.appendChild(inquiryButton);
      }

      inquiryButton.classList.remove(
        'hb-inquiry-button'
      );

      if (innerButton?.dataset.hbOriginalText) {
        innerButton.textContent =
          innerButton.dataset.hbOriginalText;
      }

      return;
    }

    if (
      innerButton &&
      !innerButton.dataset.hbOriginalText
    ) {
      innerButton.dataset.hbOriginalText =
        innerButton.textContent.trim();
    }

    if (innerButton) {
      innerButton.textContent = buttonText;

      const originalButtonStyle =
        window.getComputedStyle(addToCartButton);

      inquiryButton.style.setProperty(
        '--hb-inquiry-font-family',
        originalButtonStyle.fontFamily
      );
      inquiryButton.style.setProperty(
        '--hb-inquiry-font-size',
        originalButtonStyle.fontSize
      );
      inquiryButton.style.setProperty(
        '--hb-inquiry-font-style',
        originalButtonStyle.fontStyle
      );
      inquiryButton.style.setProperty(
        '--hb-inquiry-font-weight',
        originalButtonStyle.fontWeight
      );
      inquiryButton.style.setProperty(
        '--hb-inquiry-letter-spacing',
        originalButtonStyle.letterSpacing
      );
      inquiryButton.style.setProperty(
        '--hb-inquiry-line-height',
        originalButtonStyle.lineHeight
      );
    }

    inquiryButton.setAttribute(
      'aria-label',
      buttonText
    );

    inquiryButton.classList.add(
      'hb-inquiry-button'
    );

    addToCartButton.classList.add(
      'hb-covered-by-inquiry'
    );

    /*
      * Den echten App-Button verschieben, damit dessen
      * Klick-Handler erhalten bleibt.
      */
    if (
      inquiryButton.parentElement !==
      addToCartButton.parentElement
    ) {
      addToCartButton.insertAdjacentElement(
        'afterend',
        inquiryButton
      );
    }
  }

  function scheduleUpdate() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;
    requestAnimationFrame(updateButton);
  }

  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      'disabled',
      'class',
      'style'
    ]
  });

  scheduleUpdate();

  // Ermöglicht ein späteres Beenden oder erneutes Initialisieren
  window.destroyInquiryButtonOverlay = function () {
    observer.disconnect();
    updateScheduled = false;
    window.destroyInquiryButtonOverlay = null;
  };

  return window.destroyInquiryButtonOverlay;
}

function waitForjQuery(callback) {
    if (window.jQuery) {
        callback();
    } else {
        setTimeout(function() {
            waitForjQuery(callback);
        }, 50);
    }
}

waitForjQuery(function() {
  jQuery(document).ready(function() {    
    /* Load images immediately */
    let images = document.body.querySelectorAll('img[data-srcset]');
    if (images) {
      for (let i = 0; i < images.length; i++) {
        const element = images[i];
        const srcset = element.getAttribute('data-srcset');
        element.setAttribute('srcset', srcset);
        element.setAttribute('data-rimg', 'loaded')
        jQuery(element).next('div[data-rimg-canvas]').remove();
      }
    }

    /* Click on product slider prev/next button */
    jQuery(document).on('click', '.flickity-prev-next-button', function() {
      let galleryIndex = jQuery('button.product-gallery--media-thumbnail[data-gallery-selected="true"]').attr('data-gallery-index');
      const isNext = jQuery(this).hasClass('next');
      if (isNext) {
        const max = jQuery('.gallery-navigation--scroller button').length - 1;
        if (galleryIndex < max) {
          galleryIndex++;
        }
      } else {
        if (galleryIndex > 0) {
          galleryIndex--;  
        }
      }
      jQuery('.product-gallery--media-thumbnail[data-gallery-index="' + galleryIndex + '"]').trigger('click');
    });

    const colorMapsByLocale = {
      en: new Map([
        ['altweiß', 'old white'],
        ['aquamarin', 'aquamarine'],
        ['blau', 'blue'],
        ['braun', 'brown'],
        ['elfenbein', 'ivory'],
        ['feuerrot', 'fire red'],
        ['flieder', 'lilac'],
        ['gelb', 'yellow'],
        ['gold', 'gold'],
        ['goldgelb', 'golden yellow'],
        ['grün', 'green'],
        ['hellblau', 'light blue'],
        ['königsblau', 'royal blue'],
        ['lindgrün', 'lime green'],
        ['matt braun', 'dull brown'],
        ['matt nachtblau', 'matt midnight blue'],
        ['matt petrol', 'matte petrol'],
        ['matt schwarz', 'matt black'],
        ['matt weiß', 'matte white'],
        ['matte rose', 'matt rose'],
        ['orange', 'orange'],
        ['perlgrau', 'pearl gray'],
        ['petrol', 'petrol'],
        ['rose', 'rose'],
        ['rot', 'red'],
        ['schwarz', 'black'],
        ['weiß', 'white']
      ]),
      es: new Map([
        ['altweiß', 'blanco roto'],
        ['aquamarin', 'aguamarina'],
        ['blau', 'azul'],
        ['braun', 'marron'],
        ['elfenbein', 'marfil'],
        ['feuerrot', 'rojo fuego'],
        ['flieder', 'lila'],
        ['gelb', 'amarillo'],
        ['gold', 'oro'],
        ['goldgelb', 'amarillo dorado'],
        ['grün', 'verde'],
        ['hellblau', 'azul claro'],
        ['königsblau', 'azul real'],
        ['lindgrün', 'verde lima'],
        ['matt braun', 'marron mate'],
        ['matt nachtblau', 'azul medianoche mate'],
        ['matt petrol', 'petroleo mate'],
        ['matt schwarz', 'negro mate'],
        ['matt weiß', 'blanco mate'],
        ['matte rose', 'rosa mate'],
        ['orange', 'naranja'],
        ['perlgrau', 'gris perla'],
        ['petrol', 'petroleo'],
        ['rose', 'rosa'],
        ['rot', 'rojo'],
        ['schwarz', 'negro'],
        ['weiß', 'blanco']
      ]),
      it: new Map([
        ['altweiß', 'bianco antico'],
        ['aquamarin', 'acquamarina'],
        ['blau', 'blu'],
        ['braun', 'marrone'],
        ['elfenbein', 'avorio'],
        ['feuerrot', 'rosso fuoco'],
        ['flieder', 'lilla'],
        ['gelb', 'giallo'],
        ['gold', 'oro'],
        ['goldgelb', 'giallo dorato'],
        ['grün', 'verde'],
        ['hellblau', 'azzurro chiaro'],
        ['königsblau', 'blu reale'],
        ['lindgrün', 'verde lime'],
        ['matt braun', 'marrone opaco'],
        ['matt nachtblau', 'blu notte opaco'],
        ['matt petrol', 'petrolio opaco'],
        ['matt schwarz', 'nero opaco'],
        ['matt weiß', 'bianco opaco'],
        ['matte rose', 'rosa opaco'],
        ['orange', 'arancione'],
        ['perlgrau', 'grigio perla'],
        ['petrol', 'petrolio'],
        ['rose', 'rosa'],
        ['rot', 'rosso'],
        ['schwarz', 'nero'],
        ['weiß', 'bianco']
      ]),
      fr: new Map([
        ['altweiß', 'blanc casse'],
        ['aquamarin', 'aigue-marine'],
        ['blau', 'bleu'],
        ['braun', 'marron'],
        ['elfenbein', 'ivoire'],
        ['feuerrot', 'rouge feu'],
        ['flieder', 'lilas'],
        ['gelb', 'jaune'],
        ['gold', 'or'],
        ['goldgelb', 'jaune dore'],
        ['grün', 'vert'],
        ['hellblau', 'bleu clair'],
        ['königsblau', 'bleu roi'],
        ['lindgrün', 'vert citron'],
        ['matt braun', 'marron mat'],
        ['matt nachtblau', 'bleu nuit mat'],
        ['matt petrol', 'petrole mat'],
        ['matt schwarz', 'noir mat'],
        ['matt weiß', 'blanc mat'],
        ['matte rose', 'rose mat'],
        ['orange', 'orange'],
        ['perlgrau', 'gris perle'],
        ['petrol', 'petrole'],
        ['rose', 'rose'],
        ['rot', 'rouge'],
        ['schwarz', 'noir'],
        ['weiß', 'blanc']
      ])
    };
    const colorMap = colorMapsByLocale[Shopify.locale] || colorMapsByLocale.en;
  
    const availabilityTermsByLocale = {
      en: { Tage: 'days', Wochen: 'weeks' },
      es: { Tage: 'dias', Wochen: 'semanas' },
      it: { Tage: 'giorni', Wochen: 'settimane' },
      fr: { Tage: 'jours', Wochen: 'semaines' }
    };
    const availabilityTerms = availabilityTermsByLocale[Shopify.locale] || availabilityTermsByLocale.en;

    const translateFilterOptions = function() {
      /* Translate 'Availability' filter option */
      jQuery('div.gf-option-515504 span.gf-label').each(function() {
        const label = jQuery(this);
        const value = label.html()
          .replace('Tage', availabilityTerms.Tage)
          .replace('Wochen', availabilityTerms.Wochen);
        label.html(value);
      });      
  
      /* Translate 'Color' filter option */
      jQuery('div.gf-option-521845 span.gf-label').each(function() { 
        const label = jQuery(this);
        const value = label.html();
        if (colorMap.has(value)) {
           label.html(colorMap.get(value));
        }
      });    
    };
    
    if (Shopify.locale !== 'de') {
      const body = document.querySelector('body');
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.target.nodeName == 'BODY') {
            translateFilterOptions();
          }
  
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeName != '#text') {
              translateFilterOptions();
            }
            
            /* Translate cookie consent */
            if ((node.nodeType === Node.ELEMENT_NODE) && node.classList.contains('cc-window')) {
              jQuery('.cc-message').html('This website uses cookies to ensure you get the best experience on our website. <a aria-label="learn more about cookies" role="button" tabindex="0" class="cc-link" href="https://hedwig-bollhagen.myshopify.com/pages/privatsphare" rel="noopener noreferrer nofollow" target="_blank">Learn more</a>');
              jQuery('.cc-btn.cc-allow').html('Allow cookies');
              jQuery('.cc-btn.cc-deny').html('Deny');
              return;
            }
          });
        });
      });
      observer.observe(body, { childList: true, subtree: true });    
    }


    jQuery('.utility-bar .shopify-cross-border').wrap('<li class="utility-bar"></li>').parent().appendTo('nav.site-navigation > ul');
  
    jQuery('.navmenu-id-cookie-einstellungen a').on('click', function (e) {
      document.querySelector('.cc-revoke') && document.querySelector('.cc-revoke').click();
      e.stopPropagation();
      e.preventDefault();
      return false;
    });
    
    jQuery('div.collection--description').each(function() {
      const content = jQuery(this).html();
      const position = content.search('<!-- Sub section -->'); 
      if (position > 0) {
          const contentBeforeComment = content.substr(0, position);
          const contentAfterComment = content.substr(contentBeforeComment.length, content.length - position);
          jQuery(this).html(contentBeforeComment);
          const description = jQuery('<div class="collection--description rte"></div>').html(contentAfterComment);
          jQuery('div.collection-footer').append(description);
      }
    });
    
    function truncateHtml(content, maxChars) {
      const container = document.createElement('div');
      container.innerHTML = content;

      let remaining = maxChars;
      let splitNode = null;
      let splitOffset = 0;
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);

      while (walker.nextNode()) {
        const node = walker.currentNode;
        const text = node.nodeValue;

        if (remaining >= text.length) {
          remaining -= text.length;
          continue;
        }

        const link = jQuery(node.parentNode).closest('a', container).get(0);
        if (link) {
          splitNode = link.parentNode;
          splitOffset = Array.prototype.indexOf.call(splitNode.childNodes, link);
        } else {
          splitNode = node;
          splitOffset = text.lastIndexOf(' ', remaining);
          if (splitOffset <= 0) {
            splitOffset = remaining;
          }
        }
        break;
      }

      if (! splitNode) {
        return null;
      }

      const visibleRange = document.createRange();
      visibleRange.setStart(container, 0);
      visibleRange.setEnd(splitNode, splitOffset);

      const hiddenRange = document.createRange();
      hiddenRange.setStart(splitNode, splitOffset);
      hiddenRange.setEnd(container, container.childNodes.length);

      const visibleContainer = document.createElement('div');
      visibleContainer.appendChild(visibleRange.cloneContents());

      const hiddenContainer = document.createElement('div');
      hiddenContainer.appendChild(hiddenRange.cloneContents());

      return {
        visible: visibleContainer.innerHTML,
        hidden: hiddenContainer.innerHTML
      };
    }

    function doTextTruncate() {
      const innerWidth = window.innerWidth;
      
      jQuery('.text-truncate').each(function() {
        const readMore = jQuery(this).attr('data-read-more');
        const readLess = jQuery(this).attr('data-read-less');
              
        const height = jQuery(this).height();
        let maxChars = jQuery(this).attr('data-max-chars');
              
        if (! maxChars) {
          maxChars = 600;
          if (innerWidth >= 1024 && innerWidth < 1280) {
            maxChars = 300;
          } else if (innerWidth < 768) {
            maxChars = 200;
          }
        }
        
        let content = jQuery(this).attr('data-content');
        if (! content) {
          content = jQuery(this).html();
          jQuery(this).attr('data-content', content);
        }
          
        const plainText = jQuery('<div></div>').html(content).text();
        if (plainText.length > maxChars) {
          const truncated = truncateHtml(content, maxChars);
          if (! truncated) {
            return;
          }
          const html = truncated.visible + '<span><span class="text-truncate--hidden" style="display: none;">' + truncated.hidden + '</span> <a href="#" class="text-truncate--more-link" data-read-more="' + readMore + '" data-read-less="' + readLess + '">' + readMore + '</a></span>';
          jQuery(this).html(html);
        } else {
          jQuery(this).html(content);
        }
      });
  
      jQuery('.text-truncate--more-link').off('click.textTruncate').on('click.textTruncate', function() {
        let moreLink = jQuery(this);  
        const readMore = moreLink.attr('data-read-more');
        const readLess = moreLink.attr('data-read-less');
        
        if (moreLink.hasClass('text-truncate--less')) {
          moreLink.removeClass('text-truncate--less');
          moreLink.html(readMore);
        } else {
          moreLink.addClass('text-truncate--less');
          moreLink.html(readLess);
        }
        moreLink.parent().find('.text-truncate--hidden').toggle();
        return false;
      });  
    }
  
    doTextTruncate();
    window.addEventListener('resize', doTextTruncate);
    jQuery('.collection--text').css('visibility', 'visible');
    
    jQuery('#shopify-section-template--15882824515805__1655559171ea4ca3a8 a.featured-collection__button').click(function(event) {
      let moreLink = jQuery(this); 
      let container = moreLink.parent('.featured-collection__container');
      if (! container.find('ul.featured-collection__content').hasClass('flickity-enabled')) {
        if (container.hasClass('show')) {
          return true;
        } else {
          container.addClass('show');
          moreLink.html('Zur Form');
        }
        event.preventDefault();
        return false;
      }
      
      return true;
    });
    
    jQuery('.options-selection__option-decor a > span.more').parent().click(function(event) {
      let container = jQuery("#shopify-section-template--15882824515805__1655559171ea4ca3a8");
      jQuery([document.documentElement, document.body]).animate({
          scrollTop: container.offset().top - 150
      }, 100, 'swing', function() {
        setTimeout(function(){ 
          container.find('a.featured-collection__button').first().trigger('click');
        }, 100);
      });
      
      event.preventDefault();
      return false;
    });
  
    jQuery('.site-footer-wrapper .newsletter .newsletter-input:after').click(function(event) {
      jQuery(this).closest('form').submit();
    });
    
    document.addEventListener('animationstart', function (e) {
      if (e.animationName === 'fade-in') {
        e.target.classList.add('faded-in');
      }
    });
  
    document.addEventListener('animationend', function (e) {
      if (e.animationName === 'fade-out') {
        e.target.classList.remove('faded-in');
      }
    });
  
    jQuery('form[action="/search2"]').on('submit', function() {
      const queryInput = jQuery(this).find('input[name="q"]'); 
      let query = queryInput.val();
      query += ' tag:collection-show';
      queryInput.val(query);
      return true;
    });
  
    const hideBundles = function() {
      const bundles = jQuery('div[id^=rbr-bundle-]');
      bundles.each(function(index, bundle) {
        if (index == 1 && jQuery('a.rbr-bundle-more').length == 0) {
          jQuery(bundle).after('<a href="#" class="button button-primary rbr-bundle-more">Flexible Sets anzeigen</a>')
        }
        if (index >= 1) {
          jQuery(bundle).hide();
        }
      });    
    };
    hideBundles();
    
    document.addEventListener('bundles:created', function (e) {
      let targetNode = document.querySelector('#rbr-container-element-false');
      if (targetNode) {
        jQuery('.product-details').append(jQuery('#rbr-container-element-false'));   
        
        const bundleObserver = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              const addedNodes = Array.from(mutation.addedNodes);
              addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  hideBundles();
                }
              });
            }
          }
        });
        bundleObserver.observe(targetNode, { childList: true, subtree: true });        
      }

      targetNode = document.querySelector('#rbr-container-element-true');
      if (targetNode) {
        // jQuery('.quantity-selector').hide();
      }
    });
  
    jQuery(document).on('click', 'a.rbr-bundle-more', function (e) {
      jQuery('div[id^=rbr-bundle-]:hidden, div.product-sets--outer:hidden').fadeIn();
      jQuery(this).hide();
      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    initInquiryButtonOverlay();
  });
});

window.addEventListener('cartcount:update', function (e) {
  // console.log(e);
});

window.addEventListener('globoFilterRenderCompleted', function (e) {
  const container = document.querySelector('#gf-grid');
  const matches = container.querySelectorAll('img[data-rimg="lazy"]');
  matches.forEach((item) => {
    let event = new CustomEvent('theme:rimg:watch', { bubbles: true });
    item.dispatchEvent(event);
  });
});

window.addEventListener('globoFilterRenderSearchCompleted', function (e) {
  const container = document.querySelector('#glFilter-search-popup');
  const matches = container.querySelectorAll('img[data-rimg="lazy"]');
  matches.forEach((item) => {
    let event = new CustomEvent('theme:rimg:watch', { bubbles: true });
    item.dispatchEvent(event);
  });
});
